import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'next/error';
import Episode from '../../endpoints/Episode/Episode';
import ContentGrid from '../../grids/ContentGrid';
import Sidebar from '../../components/Sidebar/Sidebar';
import fetcher from '../../utils/fetcher';
import Query from '../../endpoints/Episode/episode.gql';
import { parseEmbeddedAssets } from '../../utils/utils';
import { getServerSession } from 'next-auth';
import { authOptions } from 'pages/api/auth/[...nextauth]';
import AdCategoriesContext from 'context/AdCategoriesContext';
import getWordCount from '../../utils/getWordCount';

/* eslint react/display-name: 0 */

const EpisodePage = ({ data, errorCode, wordcount }) => {
  if (errorCode) return <ErrorPage statusCode={errorCode} />;
  const context = useContext(AdCategoriesContext);

  useEffect(() => {
    if (data.episode.primaryCollection)
      context.setPrimaryCategory(data.episode.primaryCollection.canonicalSlug);

    if (data.episode.collections)
      context.setAdCategories(
        data.episode.collections.map((col) => col.canonicalSlug)
      );
  }, []);

  let pageTopic;

  return (
    <ContentGrid
      className="story-content-grid"
      sidebar={<Sidebar pageTopic={pageTopic} />}
    >
      <div id="mainContent"></div>
      <Episode data={data} wordcount={wordcount} />
    </ContentGrid>
  );
};

export async function getServerSideProps({
  query: { slug, previewToken },
  req,
  res,
}) {
  let data,
    errorCode = false,
    layout = 'default';

  await fetcher(Query, {
    contentAreaSlug: process.env.CONTENT_AREA_SLUG,
    slug: slug.join('/'),
    previewToken: previewToken,
  })
    .then((result) => {
      data = result;
      if (data?.episode?.embeddedAssets) {
        parseEmbeddedAssets(data.episode.embeddedAssets);
      }

      if (res) {
        res.setHeader('Cache-Control', 'public, max-age=60');
      }
      if (!data.episode) {
        if (res) res.statusCode = 404;
        errorCode = 404;
      } else {
        layout = data?.episode?.primaryCollection?.templateName;
      }
    })
    .catch(() => {
      if (res) res.statusCode = 500;
      errorCode = 500;
    });
  const session = await getServerSession(req, res, authOptions);
  const wordcount = getWordCount(data?.episode?.body);

  return {
    props: {
      data: data,
      errorCode: errorCode,
      layout,
      session,
      resourceType: data?.episode?.resourceType,
      wordcount,
    },
  };
}

EpisodePage.propTypes = {
  errorCode: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  data: PropTypes.object,
  wordcount: PropTypes.number,
};

export default EpisodePage;
